import {
    Analytics,
    initializeAnalytics,
    setUserId,
    setUserProperties,
    AnalyticsCallOptions,
    logEvent,
} from 'firebase/analytics';
import { FirebaseApp } from 'firebase/app';
import { isGoodStanding } from '../service/analytics';

export let analytics: Analytics;

export const initAnalytics = (app: FirebaseApp) => {
    analytics = initializeAnalytics(app);
    analytics.app.automaticDataCollectionEnabled = true;
};

export const setAnalyticsUser = async (token: string, userID: string) => {
    if (analytics) {
        setUserId(analytics, userID);

        const goodStanding = await isGoodStanding(token, userID);
        setUserProperties(analytics, { is_good_standing: goodStanding ? 1 : 0 });
    }
};

export const logAnalyticsEvent = (
    eventName: string,
    eventParams?: {
        coupon?: any;
        currency?: any;
        items?: any;
        payment_type?: any;
        value?: any;
        [key: string]: any;
    },
    options?: AnalyticsCallOptions,
) => {
    logEvent(analytics, eventName, eventParams, options);
};

export const logLeaderboardLookup = (streamerID: string, filter_category: string) => {
    logAnalyticsEvent('leaderboard_lookup', { id: streamerID, filter_category: filter_category });
};

export const logSearchTerm = (searchValue: string) => {
    logAnalyticsEvent('search_term', { search_term: searchValue });
};
